import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, filter, forkJoin, of, take } from 'rxjs';  
import { IndexedDBDexieService } from '../../indexedDB/service/indexed-db-dexie.service';  
import { ConfigEnviromentService } from '../../service/configEnviroment.service'; 

export const layoutResolver: ResolveFn<any> = (
  route, 
  state,  
  _indexDB: IndexedDBDexieService = inject(IndexedDBDexieService), 
  _configEnv: ConfigEnviromentService = inject(ConfigEnviromentService)
  ) => {
  const preferences = _configEnv.configReady$.pipe(
    filter(ready => ready === true),
    take(1),
    // switchMap(() => _preferenceService.getBoardConfig())
  );

  const newThemes$ = _configEnv.configReady$.pipe(
    filter(ready => ready === true),
    take(1),
    // switchMap(() => _preferenceService.getTodayThemes())
  );
  const refreshIndexAtDay = _indexDB.refreshDataAtDay();
 // const webSocketsConections = _webSocketsService.getUrlConnections()
  return forkJoin([preferences, newThemes$, refreshIndexAtDay]).pipe(
    catchError((err) => {
      return of([null, null]);
    })
  );
};
